export default __webpack_public_path__ + "static/media/calculator.f6a6b9e0.svg";